module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "forgot-password"
  }, [_c('section', {
    staticClass: "left-panel"
  }, [_c('header', [_c('div', {
    staticClass: "grid-container top"
  }, [_c('div', {
    staticClass: "col-4"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/images/global/logo.svg")
    }
  }), _vm._v(" "), _c('router-link', {
    staticClass: "btn bg-three active",
    attrs: {
      "to": "login"
    }
  }, [_vm._v("Login")])], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "grid-container"
  }, [_c('div', {
    staticClass: "col-4 vertical-centre"
  }, [(_vm.resetComplete) ? _c('div', {
    staticClass: "left-panel-centre"
  }, [_vm._m(0)]) : _c('div', {
    staticClass: "left-panel-centre"
  }, [_c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Forgot your password?"), _c('br')]), _vm._v("We'll email you a new one.")]), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.forgotPassword($event)
      }
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.email),
      expression: "email",
      modifiers: {
        "trim": true
      }
    }],
    attrs: {
      "type": "email",
      "value": "you@youremail.com"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value.trim()
      },
      "blur": function($event) {
        _vm.$forceUpdate()
      }
    }
  }), _vm._v(" "), _c('input', {
    staticClass: "btn btn-big bg-three active",
    attrs: {
      "type": "submit",
      "value": "Send Link"
    }
  })])])]), _vm._v(" "), _c('ul', {
    staticClass: "bottom"
  }, [_vm._m(1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "link navy",
    attrs: {
      "to": "terms"
    }
  }, [_vm._v("Terms & Conditions")])], 1)])])]), _vm._v(" "), _c('section', {
    staticClass: "hero-image"
  })])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "small"
  }, [_c('span', [_vm._v("Thanks!")]), _vm._v(" A link to reset your password is on it's way.")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticClass: "link blue",
    attrs: {
      "target": "_blank",
      "href": "http://planetearthinstitute.org.uk"
    }
  }, [_vm._v("Visit PEI Website")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-86efe9c6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/ForgottenPassword.vue
// module id = 723
// module chunks = 1